import { render, staticRenderFns } from "./FormDatepickerBasic.vue?vue&type=template&id=5c24977b"
import script from "./FormDatepickerBasic.vue?vue&type=script&lang=js"
export * from "./FormDatepickerBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports